import { zoomFromWheel } from '@blocksuite/std/gfx';
import { nanoid } from 'nanoid';

export { generateKeyBetween, generateNKeysBetween } from 'fractional-indexing';

export function generateElementId() {
  return nanoid(10);
}

export function normalizeWheelDeltaY(
  delta: number,
  zoom = 1,
  options?: Parameters<typeof zoomFromWheel>[2]
) {
  return zoomFromWheel(zoom, delta, options);
}

export { getBgGridGap } from './get-bg-grip-gap';
export { getLastPropsKey } from './get-last-props-key';
export * from './get-surface-block';
